// extracted by mini-css-extract-plugin
module.exports = {"storageChart":"StorageChart_storageChart__3F0Fe","loader":"StorageChart_loader__1RyGG"};